import { TextInput, Button, NativeSelect } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useAuthData } from '~/hooks/auth/use-auth-data';
import { api } from '~/trpc-extra/api';

export default function ProjectForm() {
  const trpcUtils = api.useUtils();
  const { activeOrg, orgHelper } = useAuthData();
  const orgs = orgHelper?.getOrgs();

  const { mutate: createProject, isPending: isCreatingProject } = api.project.createProject.useMutation({
    onSuccess: () => trpcUtils.project.getDefaultProject.invalidate().catch(() => undefined),
  });

  const form = useForm({
    initialValues: {
      projectName: activeOrg?.orgName || '',
      teamName: activeOrg?.orgName,
    },
    validate: {
      projectName: (x) => (x.length > 0 ? null : 'Invalid name'),
    },
  });

  return (
    <form
      className="flex w-1/3 flex-col space-y-4"
      onSubmit={form.onSubmit(({ projectName, teamName }) => {
        createProject({
          name: projectName,
          teamId: (orgs?.find((x) => x.orgName === teamName) || orgs?.at(0))!.orgId,
        });
      })}
    >
      <TextInput
        label="Project Name"
        {...form.getInputProps('projectName')}
      />
      {orgs && orgs.length > 1 ?
        <NativeSelect
          label="Team"
          {...form.getInputProps('teamName')}
          data={orgs.map((x) => x.orgName)}
        />
      : null}
      <div>
        <Button
          type="submit"
          className="mt-4"
          loading={isCreatingProject}
          styles={{
            root: {
              backgroundColor: '#00acee',
            },
          }}
        >
          Create Project
        </Button>
      </div>
    </form>
  );
}
